import { render, staticRenderFns } from "./ViewInventory.vue?vue&type=template&id=263f7b34&scoped=true"
import script from "./ViewInventory.vue?vue&type=script&lang=js"
export * from "./ViewInventory.vue?vue&type=script&lang=js"
import "./ViewInventory.vue?vue&type=style&index=0&id=263f7b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263f7b34",
  null
  
)

export default component.exports